import {useFeatureFlags} from '@components/_context';
import {FEATURE_FLAGS} from 'ui/config';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';
import {LocationApplication} from '@application/Site';

export const useIsInAppBannerDisabled = (): boolean => {
  const featureFlags = useFeatureFlags() || {};
  const tradename = ConfigurationApplication.retrieve().tradename;
  const {country} = LocationApplication.getLocale();

  return Boolean(
    featureFlags[FEATURE_FLAGS.DISABLE_IN_APP_BROWSER_BANNER] &&
    ((tradename === TradeName.LOOKIERO && country === 'FR') ||
      (tradename === TradeName.OUTFITTERY && country === 'DE')),
  );
};
